import React from "react"
import CustomButton from "../Atoms/CustomButton"
import { Navbar, Alignment } from "@blueprintjs/core"

const TrackNavbar = ({ brand, brandName, website, email, contact }) => {
  return (
    <Navbar fixedToTop={true} className="vt-track-navbar">
      <div className="container">
        <Navbar.Group className="vt-track-navbar-items h-full py-3">
          <Navbar.Heading className="vt-brand-text">
            <img className="h-12 md:h-14 lg:h-16" src={brand} alt={brandName} />
          </Navbar.Heading>
          <Navbar.Group align={Alignment.RIGHT}>
            <a href={website} target="__blank">
              <CustomButton icon="link" text="Website" minimal />
            </a>
            <Navbar.Divider />
            <a href={`mailto:${email}`} target="__blank">
              <CustomButton icon="envelope" text="Mail" minimal />
            </a>
            <Navbar.Divider />
            <a href={`tel:${contact}`}>
              <CustomButton icon="phone" text="Contact" minimal />
            </a>
          </Navbar.Group>
        </Navbar.Group>
      </div>
    </Navbar>
  )
}

export default TrackNavbar
